import {
  LOAD_EMPLOYER_PENDING_REVIEWS,
  LOAD_EMPLOYER_PENDING_REVIEWS_ERROR,
  SHOW_REVIEW_PAGE,
  CLOSE_REVIEW_PAGE,
  SHOW_FORM_THANK_YOU,
  HIDE_FORM_THANK_YOU,
  SUBMIT_REVIEW,
  SET_FORM_LOADING,
  SUBMIT_REVIEW_ERROR,
  TOGGLE_REVIEW_MODAL,
} from "../actions/types";

const initialState = {
  pendingReviews: [],
  errors: null,
  actionBarTitle: "Pending Reviews",
  loading: true,
  formLoading: false,
  formThankYou: false,
  formSubmittedSuccessfully: false,
  reviewPageActive: false,
};

export default function employerPendingReviewsReducer(
  state = initialState,
  action
) {
  const { type, payload } = action;

  switch (type) {
    case LOAD_EMPLOYER_PENDING_REVIEWS:
      return {
        ...state,
        loading: false,
        pendingReviews: payload,
        errors: null,
        formSubmittedSuccessfully: false,
      };
    case LOAD_EMPLOYER_PENDING_REVIEWS_ERROR:
      return {
        ...state,
        loading: false,
        errors: payload,
      };
    case SHOW_REVIEW_PAGE:
      return {
        ...state,
        pendingReview: payload,
        reviewPageActive: true,
        actionBarTitle: "Add a Review",
        formSubmittedSuccessfully: false,
      };
    case CLOSE_REVIEW_PAGE:
      return {
        ...state,
        pendingReview: {},
        reviewPageActive: false,
        errors: null,
      };
    case TOGGLE_REVIEW_MODAL:
      return {
        ...state,
        reviewModalActive: !state.reviewModalActive,
        pendingReview: payload,
        errors: null,
      };
    case SUBMIT_REVIEW:
      return {
        ...state,
        pendingReview: {},
        errors: null,
      };
    case SUBMIT_REVIEW_ERROR:
      return {
        ...state,
        errors: payload,
        formLoading: false,
      };
    case SHOW_FORM_THANK_YOU:
      return {
        ...state,
        formLoading: false,
        formThankYou: true,
      };
    case HIDE_FORM_THANK_YOU:
      return {
        ...state,
        formThankYou: false,
        reviewModalActive: false,
        formSubmittedSuccessfully: true,
        reviewPageActive: false,
      };
    case SET_FORM_LOADING:
      return {
        ...state,
        formLoading: true,
      };
    default:
      return state;
  }
}
